<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.74969 7.50186C8.89652 7.08447 9.18633 6.7325 9.5678 6.50831C9.94927 6.28412 10.3978 6.20217 10.8339 6.27697C11.27 6.35178 11.6655 6.57851 11.9505 6.91701C12.2354 7.2555 12.3914 7.68393 12.3907 8.1264C12.3907 9.37547 10.5171 10 10.5171 10M10.5413 12.5H10.5496M10.4164 16.6667C14.3284 16.6667 17.4997 13.4954 17.4997 9.58333C17.4997 5.67132 14.3284 2.5 10.4164 2.5C6.50434 2.5 3.33302 5.67132 3.33302 9.58333C3.33302 10.375 3.46289 11.1363 3.7025 11.8472C3.79266 12.1147 3.83775 12.2484 3.84588 12.3512C3.85391 12.4527 3.84784 12.5238 3.82273 12.6225C3.79731 12.7224 3.74118 12.8262 3.62893 13.034L2.26588 15.557C2.07146 15.9168 1.97425 16.0968 1.996 16.2356C2.01495 16.3566 2.08614 16.4631 2.19067 16.5269C2.31067 16.6001 2.5141 16.579 2.92097 16.537L7.18849 16.0958C7.31772 16.0825 7.38234 16.0758 7.44124 16.0781C7.49917 16.0803 7.54006 16.0857 7.59655 16.0987C7.65398 16.112 7.7262 16.1398 7.87065 16.1954C8.66069 16.4998 9.51904 16.6667 10.4164 16.6667Z"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
